import {ASSORTMENT_SUCCESS, ASSORTMENT_ERROR} from '../actions/assortment';

const initialState = {
    data: '',
    error: null
};

export default function reducer(state = initialState, action) {
    if (action.type === ASSORTMENT_SUCCESS) {
        return Object.assign({}, state, {
            data: action.data,
            error: null
        });
    } else if (action.type === ASSORTMENT_ERROR) {
        return Object.assign({}, state, {
            error: action.error
        });
    }
    return state;
}